import { Avatar, Button, Grid, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { WorkOrderComment as WorkOrderCommentType } from 'vendor-marketplace-shared-library';
import { createdAtTime } from '../../utilities/formatters';
import { MoreVert as MoreVertIcon } from '@mui/icons-material/';
import { useState } from 'react';
import useAuth from '../../hooks/useAuth';
import Modal from '../common/Modal';
import InLineEditTextField from '../common/InLineEditTextField';

type WorkOrderCommentProps = {
  workOrderComment: WorkOrderCommentType;
  onEdit: (id: string, content: string) => void;
  onDelete: (id: string) => Promise<void>;
  disableMenu?: boolean;
};

export default function WorkOrderComment(props: WorkOrderCommentProps) {
  const { userQuery } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleClose = () => setAnchorEl(null);

  const onSave = (value: string) => props.onEdit(props.workOrderComment.id, value);

  return (
    <>
      <Grid
        container
        direction={'column'}
        spacing={1}
        boxShadow={1}
        borderRadius={2}
        p={2}
        sx={{ backgroundColor: 'common.white' }}
      >
        {/* Top row*/}
        <Grid item>
          <Grid container sx={{ justifyContent: 'space-between' }}>
            {/* User Avatar */}
            <Grid item>
              <Grid container columnGap={1} alignItems={'center'}>
                <Grid item>
                  <Avatar
                    src={
                      props.workOrderComment.user?.procureUser?.profilePictureAttachment?.url || ''
                    }
                    alt={props.workOrderComment.user?.fullName || ''}
                  />
                </Grid>
                <Grid item>
                  <Typography>{props.workOrderComment.user?.fullName}</Typography>
                  <Typography variant={'caption'}>
                    {props.workOrderComment.user?.procureUser?.userRole?.name || 'No role'}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Grid
                container
                sx={{ alignItems: 'center', justifyContent: 'space-between' }}
                columnGap={1}
              >
                <Grid item>
                  <Typography>
                    {createdAtTime(new Date(props.workOrderComment.createdAt))}
                  </Typography>
                </Grid>
                {userQuery.data.me.id === props.workOrderComment.user!.id && !props.disableMenu && (
                  <Grid item>
                    <IconButton onClick={event => setAnchorEl(event.currentTarget)}>
                      <MoreVertIcon />
                    </IconButton>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Bottom Row */}
        <Grid item sx={{ padding: 2 }}>
          {userQuery.data.me.id === props.workOrderComment.user?.id ? (
            <InLineEditTextField onSave={onSave} content={props.workOrderComment.content} />
          ) : (
            <Typography>{props.workOrderComment.content}</Typography>
          )}
        </Grid>
      </Grid>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            setOpenDeleteModal(true);
            handleClose();
          }}
        >
          Delete
        </MenuItem>
      </Menu>
      <Modal
        title={'Delete Comment Confirmation'}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
      >
        <Grid container direction='column' rowGap={2} sx={{ paddingTop: 2 }}>
          <Grid item>
            <Typography>
              Are you sure you want to delete this comment? This action cannot be undone.{' '}
            </Typography>
          </Grid>
          <Grid item>
            <Button onClick={() => props.onDelete(props.workOrderComment.id)} color='error'>
              Delete
            </Button>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
}
